export const DeliveryPerformanceAnalyticsActionTypes = {
    API_RESPONSE_SUCCESS: '@@delivery-performance-analytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@delivery-performance-analytics/API_RESPONSE_ERROR',
    GET_ON_TIME_SHIPMENTS: '@@delivery-performance-analytics/GET_ON_TIME_SHIPMENTS',
    GET_LATE_SHIPMENTS: '@@delivery-performance-analytics/GET_LATE_SHIPMENTS',
    GET_EARLY_SHIPMENTS: '@@delivery-performance-analytics/GET_EARLY_SHIPMENTS',
    GET_DELIVERY_PERFORMANCE: '@@delivery-performance-analytics/GET_DELIVERY_PERFORMANCE',
    GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME: '@@delivery-performance-analytics/GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME',
};
